import shortid from 'shortid'


export const createId = () =>
  shortid.generate()
